import styled from "@emotion/styled";
import { Text } from "@mantine/core";

const GroupText = styled(Text)`
  color: #aab0bb;
  font-weight: 500;
  margin-bottom: 4px;
  padding-bottom: 8px;
  font-size: 12px;
  border-bottom: 1px solid #d1d5db;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default GroupText;